var map = {
	"./cnn-money-x2.png": 2062,
	"./cnn-money.png": 2258,
	"./economist-x2.png": 2063,
	"./economist.png": 2259,
	"./mashable-x2.png": 2064,
	"./mashable.png": 2260,
	"./tech-crunch-x2.png": 2065,
	"./tech-crunch.png": 2261,
	"./thenewyorker-x2.png": 2066,
	"./thenewyorker.png": 2262,
	"./thrillist-x2.png": 2067,
	"./thrillist.png": 2263,
	"./time-x2.png": 2068,
	"./time.png": 2264,
	"./usa-today-x2.png": 2069,
	"./usa-today.png": 2265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2257;